module.exports = __webpack_public_path__ + "static/media/miku-logo.b3371edf.png";